import {
  INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_STATUS,
  INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_TYPE,
} from '@/api/rest/resources/types/IndicatorProduct';
import { WidgetType } from '@/api/rest/resources/types/widget';
import { useInsituIndicatorConfigurations } from '@/hooks/useInSituIndicatorConfigurationWidgets';

export const useInSituIndicatorConfigurationForMediaMaps = () => {
  const configurations = useInsituIndicatorConfigurations({
    status: INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_STATUS.APPROVED,
    type: INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_TYPE.MEDIA_MAP,
  });

  return configurations.filter((c) => c?.widget?.type === WidgetType.o_c_insitu_media_map);
};
